

















import Vue from 'vue'
export default Vue.extend({
  methods: {
    async logout() {
      const auth2 = (window as any).gapi.auth2.getAuthInstance()
      await auth2.signOut()
      this.$router.push('/login')
    }
  }
})
